import { faArrowsSpin, faDroplet, faDumbbell, faFeather } from "@fortawesome/free-solid-svg-icons"
// @ts-ignore
import historyImage1997 from "/src/assets/history/1997.jpg"
// @ts-ignore
import historyImage1999 from "/src/assets/history/1999.png"
// @ts-ignore
import historyImage2000 from "/src/assets/history/2000.png"
// @ts-ignore
import historyImage1999Animated from "/src/assets/history/1999.webp"
// @ts-ignore
import historyImage2000Animated from "/src/assets/history/2000.webp"
// @ts-ignore
import historyImage2007 from "/src/assets/both-trucks-side-transition.png"
// @ts-ignore
import historyImage2023 from "/src/assets/history/new-website.png"

export const slogans = {
    "GID://SHOPIFY/PRODUCT/7879243366635": "The classic experience", // Fury Evo
    "GID://SHOPIFY/PRODUCT/7879241859307": "The next generation", // Fury Raw
}

export const productMarketingWeights = {
    "GID://SHOPIFY/PRODUCT/7879243366635": 330, // Fury Evo
    "GID://SHOPIFY/PRODUCT/7879241859307": 336, // Fury Raw
}

export const instagramURL = "https://www.instagram.com/furytruckco/"

export const countrySelectionEnabled = false

export const whatsNewRaw = [
    {
        icon: faDumbbell,
        title: "Lasts longer",
        description: "The Fury Raws now feature a thicker baseplate, making it more durable than ever before. So you can do the craziest skateboard tricks again, and again, and again.",
        points: [
            {
                x: 60,
                y: 35,
            },
        ]
    },
    {
        icon: faFeather,
        title: "Light as feather, without compromise.",
        description: "To compensate for the thicker baseplate, we introduced a new hollow kingpin and shorter hanger design to keep it ultralight — without compromising strength.",
        points: [
            {
                x: 42,
                y: 20
            },
            {
                x: 25,
                y: 65
            },
        ]
    },
    {
        icon: faArrowsSpin,
        title: "Precision turning",
        description: "The medium hardness bushing is tailored for the average rider, providing precision turning at every corner.",
        points: [
            {
                x: 45,
                y: 54,
            }
        ]
    },
    {
        icon: faDroplet,
        title: "Grinds like butter!",
        description: "Our trucks are well known for a very smooth grinding experience on various surfaces.",
        points: [
            {
                x: 65,
                y: 85,
            }
        ]
    }
]

export const history = [
    {
        year: 1997,
        photo: historyImage1997,
        alt: "Picture of a Plymouth Fury",
        text: "Fury Trucks were named after the Plymouth Fury, a true classic. Just as our namesake continues to define American muscle cars, Fury Trucks continues to define professional skateboarding performance."
    },
    {
        year: 1999,
        photo: historyImage1999,
        alt: "Picture of Tony Hawk doing a 900",
        text: "Tony Hawk landing the first 900 on Furys in 1999.",
        url: "https://youtu.be/4YYTNkAdDD8",
        animatedImage: historyImage1999Animated
    },
    {
        year: 2000,
        photo: historyImage2000,
        alt: "Picture of Danny Wainwright about to do an ollie",

        text: "Danny Wainwright setting the highest ollie record in 2000 – a record that would stand until 2018 – riding Fury’s.",
        url: "https://youtu.be/tKWoy0PaRZY",
        animatedImage: historyImage2000Animated
    },
    {
        year: 2007,
        photo: historyImage2007,
        alt: "Picture of the Evo truck and the Raw truck. Picture split in half with each half showing part of the truck. ",
        text: "In 2007, we took our classic flagship truck, the Fury Evo, and re-designed it to improve even further what makes it uniquely “Fury”. The result was the Fury Raw, a truck that is more rugged and durable, while remaining ultralight."
    },
    {
        year: 2023,
        photo: historyImage2023,
        alt: "Picture of the new Fury website",
        text: "In 2023, we launched our new modern website, enabling you to buy Fury Trucks directly from us!"
    }
]
